// frontend/src/pages/learning/Assignment.jsx
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import { useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './styles/AssignmentTopics.css';


const OtherAssignments = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const [fetchData, { loading }] = useFetch();
  const [assignment, setAssignment] = useState(null);
  const [error, setError] = useState(null);

  // const { state } = useLocation();
  // console.log('Location State:', state);

  // const { owner, code, title, topictype, desc } = state || {};

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // console.log('Location State:', location);

  const owner = queryParams.get('owner');
  const code = queryParams.get('code');
  const title = queryParams.get('title');
  const topictype = queryParams.get('topictype');
  const desc = queryParams.get('desc');

  const [formData, setFormData] = useState({
    userAssignmentID: 0,
    assignmentType: "",
    assignmentFor: "None",
    category: "None",
    subCategory: "None",
    owner: owner || "",
    code: code || "",
    topicType: topictype || "",
    title: title || "",
    desc: desc || "",
    statement: "",
    details1: "",
    details2: "",
    details3: "",
    details4: "",
    details5: "",
    outcome: "",
    summary: "",
    remarks: "",
    isApproved: 0,
    isFinal: 0,
    dateCreated: new Date(),
    dateUpdated: new Date(),
    isActive: 1,
    isDeleted: 0,
  });

  const [formErrors, setFormErrors] = useState({});
  const mode = assignmentId === undefined ? "add" : "update";

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { url: `/otherassignment/${assignmentId}`, method: "get", headers: { Authorization: authState.token } };
      fetchData(config, { showSuccessToast: false }).then((data) => {
        setAssignment(data.assignment);
        const jsDateCreated = new Date(data.assignment.dateCreated);
        const formattedDateCreated = `${jsDateCreated.getDate().toString().padStart(2, '0')}-${(jsDateCreated.getMonth() + 1).toString().padStart(2, '0')}-${jsDateCreated.getFullYear()}`;
        const jsDateUpdated = new Date(data.assignment.dateUpdated);
        const formattedDateUpdated = `${jsDateUpdated.getDate().toString().padStart(2, '0')}-${(jsDateUpdated.getMonth() + 1).toString().padStart(2, '0')}-${jsDateUpdated.getFullYear()}`;

        setFormData({
          userAssignmentID: data.assignment.userAssignmentID,
          assignmentType: data.assignment.assignmentType,
          assignmentFor: data.assignment.assignmentFor,
          category: data.assignment.category,
          subCategory: data.assignment.subCategory,
          owner: data.assignment.owner,
          code: data.assignment.code,
          topicType: data.assignment.topicType,
          title: data.assignment.title,
          statement: data.assignment.statement,
          details1: data.assignment.details1,
          details2: data.assignment.details2,
          details3: data.assignment.details3,
          details4: data.assignment.details4,
          details5: data.assignment.details5,
          outcome: data.assignment.outcome,
          summary: data.assignment.summary,
          remarks: data.assignment.remarks,
          isApproved: data.assignment.isApproved,
          isFinal: data.assignment.isFinal,
          dateCreated: formattedDateCreated,
          dateUpdated: formattedDateUpdated,
          isActive: data.assignment.isActive,
          isDeleted: data.assignment.isDeleted,
        });
      })
      .catch((error) => {
        console.error("Error fetching assignment data:", error);
        setError("Failed to fetch assignment data. Please try again later.");
      });
    }
  }, [mode, authState, assignmentId, fetchData]);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }

  const handleReset = e => {
    e.preventDefault();
    if (assignment) {
      setFormData(prevData => ({
        ...prevData,
        ...assignment,
        dateCreated: assignment.dateCreated.toISOString(),
        dateUpdated: assignment.dateUpdated.toISOString()
      }));
    }
  }

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateForm(formData);
  
    setFormErrors({});
  
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
  
    const navigateToAssignmentList = () => {
      navigate("/assignments-others");
    };
  
    if (mode === "add") {
      const config = { url: "/otherassignment", method: "post", data: formData, headers: { Authorization: authState.token } };
      fetchData(config)
        .then(() => {
          navigateToAssignmentList();
        })
        .catch((error) => {
          console.error("Error adding Assignment:", error);
          setError("Error adding Assignment");
        });
    } else {
      const config = { url: `/otherassignment/${assignmentId}`, method: "put", data: formData, headers: { Authorization: authState.token } };
      fetchData(config)
        .then(() => {
          navigateToAssignmentList();
        })
        .catch((error) => {
          console.error("Error updating Assignment:", error);
          setError("Error updating Assignment");
        });
    }
  };

  const validateForm = formData => {
    const errors = {};
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.statement) {
      errors.statement = "Description is required";
    } else if (formData.statement.length > 1000) {
      errors.statement = "Description cannot exceed 1000 characters";
    }
    if (!formData.details1) {
      errors.details1 = "Details 1 input is required";
    } else if (formData.details1.length > 1000) {
      errors.details1 = "Details 1 cannot exceed 1000 characters";
    }
    if (!formData.details2) {
      errors.details2 = "Details 2 input is required";
    } else if (formData.details2.length > 1000) {
      errors.details2 = "Details 2 cannot exceed 1000 characters";
    }
    if (!formData.details3) {
      errors.details3 = "Details 3 input is required";
    } else if (formData.details3.length > 1000) {
      errors.details3 = "Details 3 cannot exceed 1000 characters";
    }
    if (!formData.details4) {
      errors.details4 = "Details 4 input is required";
    } else if (formData.details4.length > 1000) {
      errors.details4 = "Details 4 cannot exceed 1000 characters";
    }
    if (!formData.details5) {
      errors.details5 = "Details 5 input is required";
    } else if (formData.details5.length > 1000) {
      errors.details5 = "Details 5 cannot exceed 1000 characters";
    }
    if (!formData.outcome) {
      errors.outcome = "Outcome / Learning input is required";
    } else if (formData.outcome.length > 1000) {
      errors.outcome = "Outcome / Learning cannot exceed 2000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )


  return (
    <>
      <MainLayout>
        <div className="bg-gray-900 text-white">
          <h3 className="text-lg mt-4 mx-8 pb-2 border-b border-gray-700">Assignments</h3>
        </div>
        <form 
          className="mx-auto my-4 p-6 border border-gray-700 shadow-lg rounded-lg bg-gray-800 md:w-7/12 w-full"
          onSubmit={handleSubmit}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="text-center mb-6">
                <h2 className="text-2xl text-yellow-300">
                  {mode === "add" ? "Add New Assignment" : "Edit Assignment"}
                </h2>
              </div>

              {/* <div className="text-yellow-400 mb-4">{formData.desc}</div> */}
              <div
                  className="text-white"
                  dangerouslySetInnerHTML={{ __html: formData.desc }}
              ></div>
              <input type="hidden" name="assignmentType" value={formData.assignmentType} />
              <input type="hidden" name="owner" value={formData.owner} />
              <input type="hidden" name="code" value={formData.code} />
              <input type="hidden" name="topicType" value={formData.topicType} />

              <div className="mb-4">
                <label htmlFor="title" className="block text-white mb-2">Complete Your Assignment for Title/Topic*</label>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={formData.title}
                  placeholder="Input Concern / Goal"
                  onChange={handleChange}
                  maxLength="100"
                  className="w-full p-3 border border-gray-600 rounded-md bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  style={{width: "100%"}}
                />
                {formErrors.title && <p className="text-red-500 mt-2">{formErrors.title}</p>}
              </div>

              <div className="mb-4">
                <label htmlFor="statement" className="block text-white mb-2">Description / Statement*</label>
                <textarea
                  name="statement"
                  id="statement"
                  value={formData.statement}
                  placeholder="Write here..."
                  onChange={handleChange}
                  maxLength="1000"
                  style={{width: "100%"}}
                  className="w-full p-3 border border-gray-600 rounded-md bg-gray-700 text-white placeholder-gray-400 h-32 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                />
                {formErrors.statement && <p className="text-red-500 mt-2">{formErrors.statement}</p>}
              </div>

              {[1, 2, 3, 4, 5].map((num) => (
                <div key={num} className="mb-4">
                  <label htmlFor={`details${num}`} className="block text-white mb-2">Details {num}*</label>
                  <textarea
                    name={`details${num}`}
                    id={`details${num}`}
                    value={formData[`details${num}`]}
                    placeholder="Write here..."
                    onChange={handleChange}
                    maxLength="1000"
                    style={{width: "100%"}}
                    className="w-full p-3 border border-gray-600 rounded-md bg-gray-700 text-white placeholder-gray-400 h-32 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  />
                  {formErrors[`details${num}`] && <p className="text-red-500 mt-2">{formErrors[`details${num}`]}</p>}
                </div>
              ))}

              <div className="mb-4">
                <label htmlFor="outcome" className="block text-white mb-2">Outcome / Learning*</label>
                <textarea
                  name="outcome"
                  id="outcome"
                  value={formData.outcome}
                  placeholder="Write here..."
                  onChange={handleChange}
                  maxLength="1000"
                  style={{width: "100%"}}
                  className="w-full p-3 border border-gray-600 rounded-md bg-gray-700 text-white placeholder-gray-400 h-32 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                />
                {formErrors.outcome && <p className="text-red-500 mt-2">{formErrors.outcome}</p>}
              </div>

              {Object.keys(formErrors).length > 0 && (
                <div className="text-red-500 text-center mb-4">
                  {Object.values(formErrors).map((error, index) => (
                    <div key={index}>{error}</div>
                  ))}
                </div>
              )}

              <div className="flex justify-center space-x-4 mt-6">
                <button
                  type="submit"
                  className="bg-yellow-500 text-white px-6 py-2 rounded-md font-semibold hover:bg-yellow-600"
                >
                  {mode === "add" ? "Add New" : "Update"}
                </button>
                <button
                  type="button"
                  className="bg-red-500 text-white px-6 py-2 rounded-md font-semibold hover:bg-red-600"
                  onClick={() => navigate("/assignments-think5whys")}
                >
                  Cancel
                </button>
                {mode === "update" && (
                  <button
                    type="button"
                    className="bg-blue-500 text-white px-6 py-2 rounded-md font-semibold hover:bg-blue-600"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>
          )}
        </form>
      </MainLayout>
    </>
  );
};

export default OtherAssignments;